import { observer } from "mobx-react";
import { Box, Typography } from "@mui/material";

const About = observer(() => {
  return (
    <Box className="page-container">
      <Typography sx={{ fontWeight: "bold", fontSize: 28, marginBottom: 2 }}>
        Om
      </Typography>
      <Box sx={{ marginBottom: 2 }}>
        <Typography>
          PIDcare Hälsodagboken är en del av det nationella kvalitetsregistret
          PIDcare.
        </Typography>
        <Typography>
          Dagboken är tillgänglig för alla patienter som tackat ja till att
          delta i PIDcare.
        </Typography>
      </Box>
      <Box sx={{ marginBottom: 2 }}>
        <Typography>
          Hälsodagboken lanserades i februari 2016 i en grundversion.
        </Typography>
        <Typography>
          Vi strävar efter att utveckla fler funktioner, t ex påminnelser om
          behandling, olika hjälpdokument och länkar till instruktioner.
        </Typography>
      </Box>
      <Box sx={{ marginBottom: 2 }}>
        <Typography>
          För att läsa mer om PIDcare var god se www.pidcare.se där också en
          instruktion för användning av Hälsodagboken finns.
        </Typography>
        <Typography>
          Utvecklingen av Hälsodagboken sker i samarbete mellan PIDcare och BCB
          Medical AB.
        </Typography>
      </Box>
      <Box sx={{ marginBottom: 2 }}>
        <Typography>
          Ansvarig utgivare är registerhållare Susanne Hansen.
        </Typography>
      </Box>
    </Box>
  );
});

export default About;
